export default {
  getShift: '/shift/getShift'
}
